// Limpia el localStorage al cerrar sesión (logout explícito en modules/login/actions.js, o el
// logout forzado del interceptor 401 en axios/index.js) SIN borrar las claves de layout del
// Dashboard B2B (dashboard_b2b_kpis_layout_{userId}/dashboard_b2b_charts_layout_{userId}, ver
// components/dashboard-b2b/layoutStorage.js) — pedido explícito: el orden/tamaño que
// el usuario dejó armado debe sobrevivir a un cierre de sesión, no solo a un refresh de página.
// Antes ambos call sites hacían localStorage.clear() a secas, que también borraba estas claves.
const PRESERVED_KEY_PREFIXES = ['dashboard_b2b_kpis_layout_', 'dashboard_b2b_charts_layout_', 'dashboard_b2b_theme']

export function clearSessionStorage() {
    try {
        const keysToRemove = []

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)

            if (key && !PRESERVED_KEY_PREFIXES.some(prefix => key.indexOf(prefix) === 0)) {
                keysToRemove.push(key)
            }
        }

        keysToRemove.forEach(key => localStorage.removeItem(key))
    } catch (e) {
        // No-op: si localStorage no está disponible no hay nada que limpiar.
    }
}
